<div>
  <div *ngIf="loading" class="loading-indicator">
    <mat-spinner diameter="45" strokeWidth='7'></mat-spinner>
  </div>

  <div class="msTeam-modalBodyScroll" *ngIf="!loading">
    <div *ngIf=isShare style="padding-left: 15px; padding-right: 15px;">
      <sharesettings-dialog #shareSettingsDialog></sharesettings-dialog>
    </div>

    <mat-list  role="list" *ngIf=!isShare>
      <!-- <div class="dflex" -->
        <div class="nodata"
        *ngIf="((recentdata.length == 0 )||(recentdata | filter: searchText :['recent','contentitem','title','location','author','username'] ).length === 0) && !loading">
        <img src="assets/ic_no_data.svg" width="90" alt="" style="padding-bottom: 10px;">
        <!-- <div class="nodata"></div> -->
        <div class="nodatatxt">
          {{noRecentData}}
        </div>
    </div>
     
      <mat-list-item role="listitem" *ngFor="let item of (recentdata | filter: searchText :['recent','contentitem','title','location','author','username'] );  let i = index; last as last">
       <mat-radio-button aria-label="Select {{item.contentitem.filetype}} {{item.newtype}} {{item.title}}" [value]="item" (keyup.enter)="clickedRow($event.value)" (change)="clickedRow($event.value)" (click)="clickedRow(item)">
        <!-- [disabled]="item.contentitem.type  == 'folder'&& item.contentitem.foldertype && item.contentitem.foldertype=='SMART'"        -->
          <div class="float-left margTop5">
            <mat-icon matListIcon style="width:30px;">
              <ng-template [ngIf]="item.contentitem.type == 'files'">
                <img src="./assets/{{getFileIcon(item.contentitem.filetype)}}_icon.svg" width="23" />
              </ng-template>
              <ng-template
                [ngIf]="item.contentitem.type  == 'folder'&& item.contentitem.foldertype && item.contentitem.foldertype=='SMART'"
                style="margin-bottom: 9px !important;">
                <img src="./assets/smart_folder_icon_new.svg" width="23">
              </ng-template>
              <ng-template
                [ngIf]="item.contentitem.type  == 'folder'&& item.contentitem.foldertype && item.contentitem.foldertype!='SMART'"
                style="margin-bottom: 9px !important;">
                <img src="./assets/folder.svg" width="23">
              </ng-template>
            </mat-icon>
          </div>
      

          <span class="lineHeight18" *ngIf="item.contentitem.type == 'files'">
      
            <!-- <span matLine matTooltip={{item.contentitem.title}}.{{item.contentitem.filetype}}
              [innerHTML]="getText(item.contentitem.title,item.contentitem.filetype) | highlight: searchText"
              class="span2">{{item.contentitem.filetype}}</span> -->
              <span matLine matTooltip={{item.contentitem.title}}.{{item.contentitem.filetype}} class="span2">{{item.contentitem.title}}.{{item.contentitem.filetype}}</span>
          <!-- </span> -->
          <!-- <span matTooltip={{item.contentitem.location}} matLine class="mat-list-item-content-smaller"
            [innerHTML]="item.contentitem.location | highlight: searchText"></span> -->
            <span matTooltip={{item.contentitem.location}} matLine class="mat-list-item-content-smaller">{{item.contentitem.location}}</span>

          <span matLine class="mat-list-item-content-smaller">
              {{item.contentitem.filesize| filesize}},{{item.contentitem.author.username}}
            <span>Modified on </span>{{item.timepublished}}<span> by </span>{{item.contentitem.author.username}}
            <!-- <span [innerHTML]="item.contentitem.author.username | highlight: searchText"></span> -->
          </span>
        </span>

        <span tabindex="0" class="lineHeight18" *ngIf="item.contentitem.type == 'folder'"
        (keyup.enter)="openFolder(item,item.contentitem.id, item.contentitem.title,item.contentitem.type)"
        (click)="openFolder(item,item.contentitem.id, item.contentitem.title,item.contentitem.type)" role="link" [attr.aria-label]="'Open folder ' +item.contentitem.title">
        <!-- <span matLine matTooltip= {{item.contentitem.title}} class="span2"> -->
          <!-- <span matLine matTooltip={{item.contentitem.title}}
            [innerHTML]="getText(item.contentitem.title,null) | highlight: searchText" class="span2"></span> -->
            <span matLine matTooltip={{item.contentitem.title}} class="span2">{{item.contentitem.title}}</span>
      
        <!-- </span> -->
          <div class="arrowIcon" style="margin-top: 3px;"></div>
        <!-- <span matTooltip={{item.contentitem.location}} matLine class="mat-list-item-content-smaller"
          [innerHTML]="item.contentitem.location | highlight: searchText"></span> -->
          <span matTooltip={{item.contentitem.location}} matLine class="mat-list-item-content-smaller">{{item.contentitem.location}}</span>

        <span matLine class="mat-list-item-content-smaller">
          {{item.contentitem.author.username}}
          <span>Modified on </span>{{item.timepublished}}<span> by </span>{{item.contentitem.author.username}}
          <!-- <span [innerHTML]="item.contentitem.author.username | highlight: searchText"></span> -->
        </span>
      </span>
        </mat-radio-button>
        <mat-divider [inset]="false" class="matlist-divider" *ngIf="!last"></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>
  <div class="msTeam-modal-footer add-divider" *ngIf="!isShare && !loading">
    <button *ngIf="isButtonVisible" type="button" mat-raised-button class="full-width msTeam-btn" 
      (click)='loadMore()'>{{loadingMessage}}</button>
  </div>
  <div class="global-footer">
    <div class="error-msg" [innerHTML]="errorMsg.str" *ngIf="errorMsg.str.length >0 && !loading"></div>

    <div class="msTeam-modal-footer-right" *ngIf="!loading && !isShare">
      <button mat-raised-button style="margin-right:10px;" (click)="closeDialog()" class="cancelBtn">Cancel</button>
      <button id="share_btn" class="msTeam-btn" mat-raised-button [disabled]="sharebutton.isDisabled" 
        (click)="shareItem()" *ngIf="errorMsg.str.length ==0">{{sharebutton.sharetitle}}</button>

      <button id="share_btn" class="msTeam-btn" mat-raised-button [disabled]="sharebutton.isDisabled" 
        (click)="shareItem()" *ngIf="errorMsg.str.length >0">{{sharebutton.sharetitledefault}}</button>
    </div>
  </div>
</div>